import React, { useState, useRef, useEffect } from 'react';
import YouTube from 'react-youtube';
import './styles.css';

const videoList = [
  {
    title: "La Dame du vendredi - Souper à 3",
    url: "https://www.youtube.com/watch?v=-KZJJKjg7bM",
    start: 1230,
    end: 1290,
  },
  {
    title: "Un ouvrier d’usine (Charlie Chaplin) - Un patron et ouvriers",
    url: "https://www.youtube.com/watch?v=6n9ESFJTnHs",
    start: 20,
    end: 62,
  },
  {
    title: "Le génie de la liberté - Charlie, des évadés et gardiens",
    url: "https://www.youtube.com/watch?v=AkLnj5pJtDI",
    start: 205,
    end: 266,
  },
  {
    title: "Le Masque",
    url: "https://www.youtube.com/watch?v=td3OM8jbBJQ",
    start: 910,
    end: 970,
  },
  {
    title: "Le Masque (suite)",
    url: "https://www.youtube.com/watch?v=td3OM8jbBJQ",
    start: 1002,
    end: 1093,
  },
  {
    title: "Que pensez-vous de… ? - 4 micros-trottoirs",
    url: "https://www.youtube.com/watch?v=5T7TSkH9smY",
    start: 52,
    end: 109,
  }
];

const ideas = [
  "J'ai perdu mon chemin...",
  "Voyons donc, il est sourd !",
  "J'ai envie de pipi !",
  "J'ai faim !",
  "J'ai peur !",
  "J'ai froid, brrr...",
  "Les extraterrestres existent-ils ?",
  "Quelle heure est-il ?",
  "Pourquoi pas !",
  "Depuis quand ?",
  "As-tu vu ce qui s’est passé ?",
  "Quel âge avez-vous ?",
  "Combien de fois faudra-t-il le répéter ?",
  "Parle plus fort, j’ai une banane dans l’oreille !",
];

const App = () => {
  const [videoUrl, setVideoUrl] = useState('');
  const [startTime, setStartTime] = useState(0);
  const [endTime, setEndTime] = useState(5);
  const [isVideoReady, setIsVideoReady] = useState(false);
  const [randomIdea, setRandomIdea] = useState('');
  const videoRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const [recording, setRecording] = useState(false);
  const [audioURL, setAudioURL] = useState(null);
  const audioRef = useRef(null);

  useEffect(() => {
    console.log('Initial page load');
  }, []);

  const handleVideoReady = (event) => {
    videoRef.current = event.target;
    videoRef.current.seekTo(startTime);
    videoRef.current.pauseVideo();
    setTimeout(() => setIsVideoReady(true), 1000); // La vidéo est prête après 1 seconde
  };

  const handleStartPlayback = () => {
    stopAudioPlayback();
    if (videoRef.current) {
      videoRef.current.seekTo(startTime);
      videoRef.current.playVideo();
      startRecording();
      console.log("La vidéo est maintenant en cours de lecture (handleStartPlayback)");
      setTimeout(() => {
        videoRef.current.pauseVideo();
        stopRecording();
      }, (endTime - startTime) * 1000);
    }
  };

  const startRecording = () => {
    stopAudioPlayback();
    setAudioURL(null); // Clear previous recording
    navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
      const mediaRecorder = new MediaRecorder(stream);
      mediaRecorderRef.current = mediaRecorder;
      mediaRecorder.start();
      setRecording(true);
      console.log("Start recording...");
      const audioChunks = [];
      mediaRecorder.ondataavailable = (e) => {
        audioChunks.push(e.data);
      };
      mediaRecorder.onstop = () => {
        const audioBlob = new Blob(audioChunks, { type: 'audio/wav' });
        const audioURL = URL.createObjectURL(audioBlob);
        setAudioURL(audioURL);
        console.log("Recording stopped, audio available at:", audioURL);
      };
    }).catch(error => {
      console.error("Error accessing media devices:", error);
      alert("Unable to access the microphone. Please check your browser permissions and try again.");
    });
  };

  const handleRestartRecording = () => {
    // Réinitialiser l'état et les variables
    if (mediaRecorderRef.current) {
        mediaRecorderRef.current.stop();
    }
    setAudioURL(null); // Effacer l'enregistrement précédent
    setRecording(false);
    
    // Réinitialiser la vidéo et les variables de temps
    if (videoRef.current) {
        videoRef.current.seekTo(startTime);
        videoRef.current.playVideo();
    }

    // Commencer un nouvel enregistrement
    navigator.mediaDevices.getUserMedia({ audio: true })
        .then(stream => {
            const mediaRecorder = new MediaRecorder(stream);
            mediaRecorderRef.current = mediaRecorder;
            mediaRecorder.start();
            setRecording(true);
            
            const audioChunks = [];
            mediaRecorder.ondataavailable = (e) => {
                audioChunks.push(e.data);
            };
            mediaRecorder.onstop = () => {
                const audioBlob = new Blob(audioChunks, { type: 'audio/wav' });
                const audioURL = URL.createObjectURL(audioBlob);
                setAudioURL(audioURL);
                console.log("Recording stopped, audio available at:", audioURL);
            };

            // Arrêter l'enregistrement après la durée totale prévue
            setTimeout(() => {
                mediaRecorder.stop();
                setRecording(false);
            }, (endTime - startTime) * 1000);
        }).catch(error => {
            console.error("Error accessing media devices:", error);
            alert("Unable to access the microphone. Please check your browser permissions and try again.");
        });
};

  const stopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      setRecording(false);
      console.log("Stop recording...");
    }
  };

  const handlePlaybackDubbed = () => {
    if (videoRef.current && audioRef.current) {
      videoRef.current.seekTo(startTime);
      videoRef.current.playVideo();
      audioRef.current.currentTime = 0;
      audioRef.current.play();
      console.log("La vidéo est maintenant en cours de lecture (handlePlaybackDubbed)");
    }
  };

  const handlePlayPause = () => {
    if (videoRef.current && audioRef.current) {
      if (videoRef.current.getPlayerState() === 1) {
        videoRef.current.pauseVideo();
        audioRef.current.pause();
      } else {
        videoRef.current.playVideo();
        audioRef.current.play();
      }
    }
  };

  const handleForwardPlayback = () => {
    if (videoRef.current && audioRef.current) {
      videoRef.current.seekTo(videoRef.current.getCurrentTime() + 5);
      audioRef.current.currentTime += 5;
    }
  };

  const handleBackwardPlayback = () => {
    if (videoRef.current && audioRef.current) {
      videoRef.current.seekTo(videoRef.current.getCurrentTime() - 5);
      audioRef.current.currentTime -= 5;
    }
  };

  const stopAudioPlayback = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };

  const handleVideoSelect = (event) => {
    const selectedVideo = videoList[event.target.value];
    if (selectedVideo) {
      setVideoUrl(selectedVideo.url);
      setStartTime(selectedVideo.start);
      setEndTime(selectedVideo.end);
      setIsVideoReady(false); // Réinitialiser l'état de préparation de la vidéo
    }
  };

  const generateRandomIdea = () => {
    const randomIndex = Math.floor(Math.random() * ideas.length);
    setRandomIdea(ideas[randomIndex]);
  };

  const opts = {
    height: '390',
    width: '640',
    playerVars: {
      autoplay: 0,
      controls: 1, // Enable player controls
      modestbranding: 1,
      rel: 0,
      disablekb: 1,
      start: startTime,
      end: endTime,
      mute: 1,
      cc_load_policy: 0, // Disable subtitles by default
      hl: 'fr', // Set interface language to French
    },
  };

  return (
    <>
      <div className="header">
        <div className="menu">
          <a href="https://www.bandeimprovisation.com/">Accueil</a>
          <a href="https://www.bandeimprovisation.com/outils-pour-impro">Outils pour impro</a>
        </div>
      </div>
      <div className="container">
        <h1>Des pros du doublage : improvisons !</h1>
        <select onChange={handleVideoSelect}>
          <option value="">Choix d’un extrait de film</option>
          {videoList.map((video, index) => (
            <option key={index} value={index}>{video.title}</option>
          ))}
        </select>
        <button className="button" onClick={handleRestartRecording} disabled={!isVideoReady}>
          {recording ? 'Enregistrement en cours...' : 'Commencer l\'enregistrement'}
        </button>
        <div className="video-container video-large">
          {videoUrl && (
            <YouTube
              videoId={new URL(videoUrl).searchParams.get('v')}
              opts={opts}
              onReady={handleVideoReady}
            />
          )}
        </div>
        {audioURL && (
          <div className="controls">
            <div className="control-buttons">
              <button className="button" onClick={handlePlaybackDubbed}>Écouter l’enregistrement </button>
              <button className="button" onClick={handlePlayPause}>Pause / Reprendre </button>
            </div>
            <div className="control-buttons">
              <button className="button" onClick={handleBackwardPlayback}>Reculer de 5 secondes</button>
              <button className="button" onClick={handleForwardPlayback}>Avancer de 5 secondes</button>
            </div>
          </div>
        )}
        <button className="idea-button" onClick={generateRandomIdea}>
          En manque d’imagination ?<br />Générateur d'idées
        </button>
        {randomIdea && <div className="idea">{randomIdea}</div>}
        <div className="advanced-options">
          <label>
            Lien vidéo (ou autre lien de Youtube)
            <input
              type="text"
              placeholder="URL de la vidéo"
              value={videoUrl}
              onChange={(e) => setVideoUrl(e.target.value)}
            />
          </label>
          <label>
            Début de la vidéo (en secondes)
            <input
              type="number"
              placeholder="Temps de début (en secondes)"
              value={startTime}
              onChange={(e) => setStartTime(parseInt(e.target.value, 10))}
            />
          </label>
          <label>
            Fin de la vidéo (en secondes)
            <input
              type="number"
              placeholder="Temps de fin (en secondes)"
              value={endTime}
              onChange={(e) => setEndTime(parseInt(e.target.value, 10))}
            />
          </label>
        </div>
        {audioURL && (
          <audio ref={audioRef} src={audioURL} controls />
        )}
      </div>
    </>
  );
};

export default App;

